import { CASE_REPO } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: CASE_REPO,
  okAction: 'import',
  callBackAction: 'TestCaseSharedImportCb',
  view: {
    title: '批量导入测试用例',
    content: [
      {
        $id: 'templateDownload',
        $type: 'sky-caseRepo-link'
      },
      {
        $id: 'fileName',
        $type: 'upload-file',
        label: '测试用例文档',
        rules: [
          { notEmpty: { message: '测试用例文档不能为空' } },
          'longLength',
          { fileSize: { min: 1 } },
          {
            suffix: {
              includeSuffixes: ['xlsx'],
              errorMessage: '请选择Excel文档格式的文件进行上传'
            }
          }
        ],
        props: {
          ellipsisMessage: true
        }
      },
      {
        $id: 'uploadDesc',
        $type: 'sky-alert-description',
        $el: {
          label: '请先下载导入模板并按格式填写后，再进行上传',
          hasList: true,
          type: 'warning'
        }
      }
    ]
  }
}
